import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

import logo from "./savationChristLogo.png";

const AdmissionDataFormPDF = ({ gradeClass = null }) => {
  const gradeClassName =
    typeof gradeClass === "object"
      ? gradeClass?.name ||
        gradeClass?.grade_name ||
        gradeClass?.title ||
        ""
      : gradeClass || "";

  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.page}>
        <View style={styles.header}>
          <View style={styles.logoBox}>
            <Image src={logo} style={styles.logo} />
          </View>

          <View style={styles.schoolInfo}>
            <Text style={styles.schoolName}>
              SAVATION IN CHRIST SCHOOL
            </Text>

            <Text style={styles.schoolMotto}>
              Equiping For A Better Future
            </Text>

            <Text style={styles.schoolLocation}>
              Zazay Community, Paynesville City, Monrovia
            </Text>

            {/* <Text style={styles.schoolContact}>
              Tel: ____________________ | Email: ____________________
            </Text> */}
          </View>
        </View>

        <View style={styles.titleBox}>
          <Text style={styles.title}>
            STUDENT ADMISSION DATA FORM
          </Text>

          <Text style={styles.subtitle}>
            Please complete all required information clearly using black or blue ink.
          </Text>
        </View>

        <View style={styles.gradeSection}>
          <Text style={styles.gradeLabel}>
            GRADE / CLASS
          </Text>

          <Text style={styles.gradeValue}>
            {gradeClassName}
          </Text>
        </View>

        <View style={styles.photoRow}>
          <View style={styles.photoText}>
            <Text style={styles.photoHeading}>
              STUDENT PHOTOGRAPH
            </Text>

            <Text style={styles.photoInstruction}>
              Attach recent passport-size photograph.
            </Text>
          </View>

          <View style={styles.photoBox}>
            <Text style={styles.photoBoxText}>
              PASSPORT
            </Text>

            <Text style={styles.photoBoxText}>
              PHOTO
            </Text>
          </View>
        </View>

        <SectionTitle title="1. PERSONAL INFORMATION" />

        <View style={styles.row}>
          <BlankField
            label="Full Name"
            width="100%"
          />
        </View>

        <View style={styles.row}>
          <BlankField label="Gender" />
          <BlankField label="Date of Birth" />
        </View>

        <View style={styles.row}>
          <BlankField label="Nationality" />
          <BlankField label="County of Origin" />
        </View>

        <View style={styles.row}>
          <BlankField
            label="Address"
            width="100%"
          />
        </View>

        <View style={styles.row}>
          <BlankField label="Health Status" />
          <BlankField label="Hobby" />
        </View>

        <SectionTitle title="2. ACADEMIC INFORMATION" />

        <View style={styles.row}>
          <BlankField label="Previous Class" />
          <BlankField label="Previous School" />
        </View>

        <View style={styles.row}>
          <BlankField label="Major Subject" />
          <BlankField label="Division Assigned" />
        </View>

        <View style={styles.row}>
          <BlankField label="Academic Year" />
          <BlankField label="Semester Status" />
        </View>

        <View style={styles.row}>
          <BlankField label="Student Status" />
          <BlankField label="Admission Status" />
        </View>

        <SectionTitle title="3. PARENT / GUARDIAN INFORMATION" />

        <View style={styles.row}>
          <BlankField label="Mother's Name" />
          <BlankField label="Father's Name" />
        </View>

        <View style={styles.row}>
          <BlankField
            label="Parent / Guardian Contact"
            width="100%"
          />
        </View>

        <View style={styles.row}>
          <BlankField
            label="Parent / Guardian Address"
            width="100%"
          />
        </View>

        <SectionTitle title="4. DECLARATION" />

        <View style={styles.declaration}>
          <Text style={styles.declarationText}>
            I hereby declare that the information provided on this admission
            form is true and correct to the best of my knowledge. I understand
            that any false information may affect the student's admission or
            enrollment status.
          </Text>
        </View>

        <View style={styles.signatureRow}>
          <SignatureField label="Parent / Guardian Signature" />
          <SignatureField label="Admission Officer" />
          <SignatureField label="School Administrator" />
        </View>

        <View style={styles.footer}>
          <Text style={styles.footerText}>
            SAVATION CHRIST SCHOOL
          </Text>

          <Text style={styles.footerText}>
            Official Student Admission Form
          </Text>
        </View>
      </Page>
    </Document>
  );
};

const SectionTitle = ({ title }) => {
  return (
    <View style={styles.sectionHeader}>
      <Text style={styles.sectionTitle}>
        {title}
      </Text>
    </View>
  );
};

const BlankField = ({
  label,
  width = "49%",
}) => {
  return (
    <View
      style={[
        styles.field,
        {
          width,
        },
      ]}
    >
      <Text style={styles.fieldLabel}>
        {label}
      </Text>

      <View style={styles.writingLine} />
    </View>
  );
};

const SignatureField = ({ label }) => {
  return (
    <View style={styles.signatureField}>
      <View style={styles.signatureLine} />

      <Text style={styles.signatureLabel}>
        {label}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 12,
    paddingBottom: 30,
    paddingHorizontal: 24,
    backgroundColor: "#FFFFFF",
    fontFamily: "Helvetica",
  },

  header: {
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: 7,
    borderBottomWidth: 1.5,
    borderBottomColor: "#1E3A5F",
  },

  logoBox: {
    width: 56,
    height: 56,
    marginRight: 10,
    alignItems: "center",
    justifyContent: "center",
  },

  logo: {
    width: 52,
    height: 52,
    objectFit: "contain",
  },

  schoolInfo: {
    flex: 1,
  },

  schoolName: {
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    color: "#1E3A5F",
    letterSpacing: 0.5,
  },

  schoolMotto: {
    marginTop: 2,
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    color: "#C8A74E",
  },

  schoolLocation: {
    marginTop: 2,
    fontSize: 7,
    color: "#4B5563",
  },

  schoolContact: {
    marginTop: 2,
    fontSize: 6.5,
    color: "#6B7280",
  },

  titleBox: {
    marginTop: 6,
    paddingVertical: 6,
    paddingHorizontal: 7,
    alignItems: "center",
    backgroundColor: "#F3F6F9",
    borderWidth: 0.7,
    borderColor: "#DCE4EC",
    borderRadius: 3,
  },

  title: {
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
    color: "#1E3A5F",
    letterSpacing: 0.6,
  },

  subtitle: {
    marginTop: 2,
    fontSize: 6,
    color: "#6B7280",
  },

  gradeSection: {
    marginTop: 5,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 5,
    paddingHorizontal: 7,
    backgroundColor: "#FBF8EE",
    borderWidth: 0.7,
    borderColor: "#E5D9AD",
    borderRadius: 3,
  },

  gradeLabel: {
    width: 95,
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    color: "#1E3A5F",
  },

  gradeValue: {
    flex: 1,
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    color: "#111827",
  },

  photoRow: {
    marginTop: 5,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: 58,
  },

  photoText: {
    flex: 1,
  },

  photoHeading: {
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    color: "#1E3A5F",
  },

  photoInstruction: {
    marginTop: 2,
    fontSize: 6,
    color: "#6B7280",
  },

  photoBox: {
    width: 52,
    height: 58,
    borderWidth: 0.8,
    borderColor: "#9CA3AF",
    borderStyle: "dashed",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FAFAFA",
  },

  photoBoxText: {
    fontSize: 5.5,
    color: "#9CA3AF",
  },

  sectionHeader: {
    marginTop: 5,
    marginBottom: 3,
    paddingVertical: 3.5,
    paddingHorizontal: 6,
    backgroundColor: "#EAF1F8",
    borderLeftWidth: 2.5,
    borderLeftColor: "#C8A74E",
  },

  sectionTitle: {
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    color: "#1E3A5F",
    letterSpacing: 0.3,
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
  },

  field: {
    minHeight: 27,
    marginBottom: 3,
    paddingHorizontal: 6,
    paddingVertical: 3.5,
    backgroundColor: "#FFFFFF",
    borderWidth: 0.7,
    borderColor: "#D8E0E8",
    borderRadius: 2,
  },

  fieldLabel: {
    fontSize: 5.8,
    fontFamily: "Helvetica-Bold",
    color: "#64748B",
    textTransform: "uppercase",
  },

  writingLine: {
    marginTop: 5,
    height: 8,
    borderBottomWidth: 0.7,
    borderBottomColor: "#94A3B8",
  },

  declaration: {
    paddingHorizontal: 7,
    paddingVertical: 6,
    backgroundColor: "#FAFBFC",
    borderWidth: 0.7,
    borderColor: "#E2E8F0",
    borderRadius: 3,
  },

  declarationText: {
    fontSize: 6,
    lineHeight: 1.35,
    color: "#4B5563",
  },

  signatureRow: {
    marginTop: 14,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  signatureField: {
    width: "30%",
    alignItems: "center",
  },

  signatureLine: {
    width: "100%",
    height: 20,
    borderBottomWidth: 0.8,
    borderBottomColor: "#475569",
  },

  signatureLabel: {
    marginTop: 3,
    fontSize: 5.5,
    color: "#64748B",
    textAlign: "center",
  },

  footer: {
    position: "absolute",
    left: 24,
    right: 24,
    bottom: 8,
    paddingTop: 4,
    borderTopWidth: 0.7,
    borderTopColor: "#E5E7EB",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  footerText: {
    fontSize: 5,
    color: "#9CA3AF",
  },
});

export default AdmissionDataFormPDF;

